import { useLocation } from "@tanstack/react-router";
import { useEffect } from "react";
import { initPostHog, trackPageView } from "../lib/posthog";

// Initialize PostHog when the component mounts
let initialized = false;

export function PostHogProvider({ children }: { children: React.ReactNode }) {
	const location = useLocation();

	// Initialize PostHog once
	useEffect(() => {
		if (!initialized) {
			initPostHog();
			initialized = true;
		}
	}, []);

	// Track page views on route change
	useEffect(() => {
		// Get page title from route
		const pageTitle = getPageTitle(location.pathname);
		trackPageView(location.pathname, pageTitle);
	}, [location.pathname]);

	return <>{children}</>;
}

// Map routes to page titles for better analytics
function getPageTitle(pathname: string): string {
	const titles: Record<string, string> = {
		"/": "Landing Page",
		"/calculator": "Day Calculator",
		"/year": "Year View",
		"/pricing": "Pricing",
		"/login": "Login",
	};

	return titles[pathname] || "Unknown Page";
}

export default PostHogProvider;
